import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import KISApp from './KISApp';
import { Analytics } from "@vercel/analytics/react";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <KISApp />
    <Analytics />
  </React.StrictMode>
);
